import { bindMenuConfig }    from './bindMenuConfig';
import { bindCellEvents }    from './bindCellEvents';
import { bindMapClick }      from './bindMapClick';
import { bindExtentWatcher } from './bindExtentWatcher';

export const bindAllEvents = (params) => {
  // All helpers now accept the same 'params' object
  bindMenuConfig(params);
  
  const cleanupCells = bindCellEvents(params);
  const cleanupMap   = bindMapClick(params);
  const cleanupExt   = bindExtentWatcher(params);

  return () => {
    cleanupCells?.();
    cleanupMap?.();
    cleanupExt?.();
    
    // Final cleanup of the highlight layer from the map
    if (params.mapView?.map && params.highlightLayer) {
      params.mapView.map.remove(params.highlightLayer);
    }
  };
};